"use client";

import { useEffect } from "react";
import { useAppContext } from "@/app/contextProviders/app-context";

/**
 * Sets is404 in AppContext so PageView includes is_404 in the dataLayer event.
 * Resets on unmount so navigating away from a 404 clears the flag.
 */
const NotFoundSignal = () => {
	const { setIs404 } = useAppContext();

	useEffect(() => {
		setIs404(true);
		return () => setIs404(false);
	}, [setIs404]);

	return null;
};

export default NotFoundSignal;
